/*
 * Model which handles loading the last refresh time from the server, as well as
 * triggering an update of a KB on the server
 */

define(["backbone", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Messenger,
  Properties,
) {
  var KbRefreshMenuModel = {};

  /*
   * Model that stores the last updated timestamp, average refresh time, and whether the KB is loaded.
   */
  KbRefreshMenuModel.kbRefreshMenuModel = Backbone.Model.extend({
    defaults: {
      lastUpdateTimestamp: 0,
      kbId: 0,
      loaded: false,
    },
    update: function () {
      //create an update model and post a request to update the KB
      var update = new KbRefreshMenuModel.updateModel({ kbId: this.get("kbId") });
      return update;
    },
    url: function () {
      return Properties.rootURL + "/" + this.get("kbId") + "/refresh";
    },
  });

  /*
   * Model that is used to update a KB and check on the status of the update
   */
  KbRefreshMenuModel.updateModel = Backbone.Model.extend({
    idAttribute: "updateId",
    url: function () {
      if (this.id) return Properties.rootURL + "/" + this.get("kbId") + "/updates/" + this.id;
      else return Properties.rootURL + "/" + this.get("kbId") + "/updates";
    },
    isSuccessful: function () {
      return this.get("successful");
    },
    isFailed: function () {
      return this.get("failed");
    },
  });

  Messenger.reqres.setHandler(
    "active:kb:refresh:model",
    function () {
      //get the active kbId
      var kbId = Messenger.reqres.request("active:kb");
      console.log("kbid: " + kbId);
      var model = new KbRefreshMenuModel.kbRefreshMenuModel({ kbId: kbId });
      model.fetch();
      return model;
    },
    this,
  );

  return KbRefreshMenuModel;
});
